// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"BurgerMenu_menuItems__1cRFu","open":"BurgerMenu_open__sYOJB","menuItem":"BurgerMenu_menuItem__Z3AGj"};